import { render, staticRenderFns } from "./quotation.vue?vue&type=template&id=371d5bae"
import script from "./quotation.vue?vue&type=script&lang=js"
export * from "./quotation.vue?vue&type=script&lang=js"
import style0 from "../assets/css/quotation.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../assets/css/quotation-mobile.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports